import { DemandHqId, ProductId } from "../DemandIds";

export interface ProductIdFields {
    productId: ProductId;
}

export interface ProductRelationshipFields {
    demandHqId: DemandHqId;
}
